import GiftCards from './GiftCards'

export default GiftCards
